"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanningState = void 0;
const rc_js_util_1 = require("rc-js-util");
const e_pointer_event_type_1 = require("../internal-events/e-pointer-event-type");
class PanningState {
    constructor(startEvent, options, providers, sharedState) {
        this.startEvent = startEvent;
        this.options = options;
        this.providers = providers;
        this.sharedState = sharedState;
        this.previousClientX = startEvent.$event.clientX;
        this.previousClientY = startEvent.$event.clientY;
        // the starting event is one that needs to be handled straight away
        this.handlePointerEvent(e_pointer_event_type_1.EPointerEventType.Move, this.startEvent);
    }
    handleMouseEvent() {
        return null;
    }
    handlePointerEvent(eventType, chartEvent) {
        switch (eventType) {
            case e_pointer_event_type_1.EPointerEventType.Out:
            case e_pointer_event_type_1.EPointerEventType.Up:
                {
                    if (this.startEvent.$event.pointerId !== chartEvent.$event.pointerId) {
                        return null;
                    }
                    return this.providers.stateFactories.getIdleState(null, this.options, this.providers, this.sharedState);
                }
            case e_pointer_event_type_1.EPointerEventType.Down:
                {
                    return rc_js_util_1._Fp.valueOrNull(chartEvent.$event.pointerId !== this.startEvent.$event.pointerId, this.providers.stateFactories.getPinchZoomingState(this.startEvent, chartEvent, this.options, this.providers, this.sharedState));
                }
            case e_pointer_event_type_1.EPointerEventType.Move:
                {
                    if (this.startEvent.$event.pointerId === chartEvent.$event.pointerId) {
                        const dx = chartEvent.$event.clientX - this.previousClientX;
                        const dy = chartEvent.$event.clientY - this.previousClientY;
                        const dims = this.providers.attachPoint.canvasDims;
                        // -y to normalize direction into clip space system
                        this.providers.callbacks.onPan(chartEvent, dx * dims.dpr, -dy * dims.dpr);
                        this.previousClientX = chartEvent.$event.clientX;
                        this.previousClientY = chartEvent.$event.clientY;
                    }
                    return null;
                }
        }
        return rc_js_util_1._Production.assertValueIsNever(eventType);
    }
}
exports.PanningState = PanningState;
//# sourceMappingURL=panning-state.js.map